import { ExpressDataRow } from "../../types/express-data.type";
import { EXPRESS_DATA_COLUMNS, formatExpressCellValue } from "./utils";
import Skeleton from "@mui/material/Skeleton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

interface ExpressDataTableProps {
  data: ExpressDataRow[];
  loading: boolean;
}

const renderSkeletonRows = (limit: number) =>
  Array.from({ length: limit }).map((_, index) => (
    <TableRow key={index}>
      {EXPRESS_DATA_COLUMNS.map((column) => (
        <TableCell key={column.key}>
          <Skeleton variant="text" />
        </TableCell>
      ))}
    </TableRow>
  ));

export default function ExpressDataTable({
  data,
  loading,
}: ExpressDataTableProps) {
  return (
    <TableContainer sx={{ overflowX: "auto" }}>
      <Table stickyHeader>
        <TableHead
          sx={{
            bgcolor: (theme) => theme.palette.background.default,
          }}
        >
          <TableRow>
            {EXPRESS_DATA_COLUMNS.map((column) => (
              <TableCell
                key={column.key}
                align={column.align ?? "left"}
                sx={{
                  minWidth: column.minWidth,
                  fontWeight: 600,
                  borderRight: (theme) =>
                    `1px solid ${theme.palette.draft.main}`,
                  bgcolor: (theme) => theme.palette.background.default,
                  whiteSpace: "nowrap",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {loading && renderSkeletonRows(10)}
          {!loading && data.length === 0 && (
            <TableRow>
              <TableCell
                colSpan={EXPRESS_DATA_COLUMNS.length - 11}
                align="center"
                sx={{ py: 5 }}
              >
                <Typography color="text.secondary" fontWeight={500}>
                  ไม่พบข้อมูล
                </Typography>
              </TableCell>
            </TableRow>
          )}
          {!loading && data.map((item, index) => (
            <TableRow
              key={item.uuid}
              sx={{
                bgcolor: index % 2 === 1 ? "#f6f6f9" : "#fff",
                "& td": { padding: "8px" },
              }}
            >
              {EXPRESS_DATA_COLUMNS.map((column) => {
                const value = formatExpressCellValue(item, column);

                return (
                  <TableCell
                    key={column.key}
                    align={column.align ?? "left"}
                    title={value}
                    sx={{
                      maxWidth: 220,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      borderRight: (theme) =>
                        `1px solid ${theme.palette.draft.main}`,
                    }}
                  >
                    {value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
